export default __webpack_public_path__ + "static/parsha-guide-header-e0cccc285289023c5b834dce95c54e96.png";